import { api } from '../api';

// Create booking (client)
export const createBooking = async (bookingData) => {
  const result = await api.createBooking(bookingData);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data.id;
};

// Get booking by ID
export const getBooking = async (bookingId) => {
  const result = await api.getBooking(bookingId);
  if (result.error) {
    return null;
  }
  return result.data;
};

// Get bookings by client
export const getClientBookings = async (clientId) => {
  const result = await api.getClientBookings(clientId);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

// Get bookings by host
export const getHostBookings = async (hostId) => {
  const result = await api.getHostBookings(hostId);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

// Get inquiries by host (type: 'inquiry')
export const getHostInquiries = async (hostId) => {
  const result = await api.getHostInquiries(hostId);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

// Get bookings by host (type: 'booking' or no type)
export const getHostBookingsOnly = async (hostId) => {
  const result = await api.getHostBookingsOnly(hostId);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

// Get inquiries by client
export const getClientInquiries = async (clientId) => {
  const result = await api.getClientInquiries(clientId);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

// Get bookings by trip
export const getTripBookings = async (tripId) => {
  const result = await api.getTripBookings(tripId);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

// Update booking status
export const updateBookingStatus = async (bookingId, status) => {
  const result = await api.updateBookingStatus(bookingId, status);
  if (result.error) {
    throw new Error(result.error);
  }
};

// Cancel booking (client can cancel their own)
export const cancelBooking = async (bookingId) => {
  const result = await api.cancelBooking(bookingId);
  if (result.error) {
    throw new Error(result.error);
  }
};

